import i18next, { changeLanguage } from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import de from './locales/de.json';
import { DEFAULT_LOCALE, resolveInitialLocale, isSupportedLocale, type SupportedLocale } from './config';
import { applyLocaleSeo } from './seo';

const resources = {
  en: { translation: en },
  // Placeholder entries — fallbackLng serves English until es/fr are added
  es: { translation: en },
  fr: { translation: en },
  de: { translation: de },
};

i18next.use(initReactI18next).init({
  resources,
  lng: resolveInitialLocale(),
  fallbackLng: DEFAULT_LOCALE,
  interpolation: {
    escapeValue: false,
  },
  returnEmptyString: false,
});

document.documentElement.lang = resolveInitialLocale();

applyLocaleSeo();

export function setLocale(locale: SupportedLocale): Promise<void> {
  try {
    localStorage.setItem('toyo-locale', locale);
  } catch {
    // ignore
  }
  document.documentElement.lang = locale;
  return changeLanguage(locale).then(() => {
    applyLocaleSeo();
  });
}

export function getLocale(): SupportedLocale {
  const instance = i18next as { language?: string };
  const lang = (instance.language || DEFAULT_LOCALE).split('-')[0];
  return isSupportedLocale(lang) ? lang : DEFAULT_LOCALE;
}

export { useTranslation } from 'react-i18next';
export { type SupportedLocale, type SelectableLocale, SELECTABLE_LOCALES } from './config';
export default i18next;
